import { useState,useRef,useEffect, useMemo } from 'react'
import { useThree } from '@react-three/fiber'
import {gsap} from 'gsap'
import { useFrame } from '@react-three/fiber'
import * as THREE from 'three'
import $ from 'jquery'

export default function Maisons() {

    const bulleRef = useRef([])

    const infoRef = useRef()

    const state = useThree();

    const [survole, setSurvole] = useState(false)

    var [tourne,setTourne] = useState(true)

    const vec = new THREE.Vector3();

    const [controls, setControls] = useState(null);

    useEffect(() => {
      document.body.style.cursor = survole ? 'pointer' : 'auto'
    }, [survole])


    
    const [angle, setAngle] = useState(0)

    var angleTourne = 0
    
    const[activeX,setActiveX] = useState(8)
    const[activeZ,setActiveZ] = useState(8)

    useFrame((state,delta) => {
        state.controls.autoRotate = tourne
        //state.controls.update()
        //  if (tourne) {
        //     state.camera.lookAt(0, 0, 0)
        //     angleTourne -= delta / 20
        //     vec.set(Math.cos(angle + angleTourne)*8, 1, Math.sin(angle + angleTourne)*8)
        //     state.camera.position.lerp(vec, .008)
        //  } 
        return null
    })
       
    var nombreMaisons = 10

    const coordonnees = useMemo(()=> {
        const coordonnees = []
            for(let i = 0; i < nombreMaisons; i++)
            {
                const orientationMaison = Math.random() * Math.PI  // Random angle

                const angle = (Math.random()/2 + 0.5 + i) * (Math.PI / 5) // Random angletr
                const radius =  Math.random()   + 3    // Random radius
                const x = Math.cos(angle) * radius        // Get the x position using cosinus
                const z = Math.sin(angle) * radius        // Get the z position using sinus

                coordonnees.push(orientationMaison,x,z)
            }
            return coordonnees
    }, [])




    var names = ['Michel','Caroline','Kevin','Mathilde','Roger','Marion','Georges','Natacha','Jean-Jacques','Sylvie']

    const cercle = new THREE.SphereGeometry(1,20,20,0, Math.PI, Math.Pi)
    const boite = new THREE.BoxGeometry(0.4,0.3,0.6 )
    const sphere = new THREE.SphereGeometry(40, 40, 20)
    const triangle = new THREE.Shape()
        .moveTo( -0.25, 0 )
        .lineTo( 0.25, 0 )
        .lineTo( 0, 0.15 )
        .lineTo( -0.25, 0 ); // close path
    const extrudeSettings = { depth: 0.6, bevelEnabled: false, bevelSegments: 2, steps: 2, bevelSize: 1, bevelThickness: 1 };
    let toit = new THREE.ExtrudeGeometry( triangle, extrudeSettings )
    const matMaison = new THREE.MeshLambertMaterial({color:'#916233'})
    const matToit = new THREE.MeshLambertMaterial({color:'#604b35'})
    const matToitRouge = new THREE.MeshLambertMaterial({color:'#660000'})


    var maisons = Array()





    for(let i = 0; i < nombreMaisons; i++)
    {

        maisons.push(
            <group 
                key = {i}
                rotation-y = {coordonnees[i*3]}
                position =  {[coordonnees[i*3 + 1],0,coordonnees[i*3 + 2]]}
                name = {names[i]} >
                {/* BATI */}
                <mesh 
                    receiveShadow 
                    castShadow 
                    position = {[0,0.15,0]}
                    geometry  = {boite}
                    material ={matMaison}
                    >
                </mesh> 
                {/* PORTE */}
                <mesh 
                    receiveShadow 
                    position = {[0,0.08,0]}
                    rotation-y={Math.PI/2}
                    scale = {[0.3,0.6,0.7] }
                    geometry  = {boite}
                    material ={matToit}
                    >
                </mesh> 
                {/* TOIT */}
                <mesh 
                    receiveShadow 
                    castShadow 
                    position = {[0, 0.3, - 0.3]}
                    geometry  = {toit}
                    material ={i%2 ? matToit : matToitRouge}
                    >
                </mesh> 
                {/* BULLE */}
                <mesh 
                    ref={element => (bulleRef.current[i] = element)}
                    onPointerEnter = { (event) =>
                        {
                            event.stopPropagation()
                            bulleRef.current[i].material.opacity = 0.3
                            setSurvole(!survole)
                        } 
                     }
                    onPointerLeave = { (event) =>
                        {
                            bulleRef.current[i].material.opacity = 0
                            setSurvole(!survole)
                        }  
                    }
                    onClick = { () =>
                        {
                            
                            setTourne(false)
                            var pX = coordonnees[i*3 + 1]
                            var pZ = coordonnees[i*3 + 2]    
                            setActiveX(pX * 2.2) 
                            setActiveZ(pZ * 2.2)
                            gsap.to(state.camera.position, { duration: 1, x:pX * 1.5, y:0.5, z:pZ * 1.5, ease:'ease.out'}),
                            gsap.to(state.camera.lookAt, { duration: 1, x:pX, y:0.15, z:pZ,  ease:'ease.out'})  
                            //setAngle (Math.atan2(pZ, pX))
                            //state.controls.update()
                            //state.camera.updateProjectionMatrix()
                            $('#infos').html('<h1>La maison de '+bulleRef.current[i].parent.name+'</h1><br>X : '+Math.round(coordonnees[i*3 + 1] * 100) / 100+' | Z : '+Math.round(coordonnees[i*3 + 2] * 100) / 100)
                            $('#infos').fadeIn('slow')

                        }

                    } 
                    onPointerMissed = { () => 
                        {
                            if(!tourne) {

                                $('#infos').html('')
                                //$('#infos').fadeOut('slow')
                                //console.log(tX)
                                gsap.to(state.camera.position, { duration: 0.5, x:activeX, y:1.5, z:activeZ, ease:'ease.out'}),
                                gsap.to(state.camera.lookAt, { duration: 0.5, x:0, y:0, z:0,  ease:'ease.out'})  
                                //state.controls.dispose()
                                //state.camera.updateProjectionMatrix()
                                setTourne(true)
                            }
                    }

                    }
                    rotation-x = {- Math.PI * 0.5}
                    position = {[0,0.002,0]}
                    geometry  = {cercle}
                    >
                        <meshStandardMaterial color={ 'white'} opacity= {0} transparent /> 
                </mesh> 

            </group>

        )
    }

    return maisons
} 
